export function lightOrDarkFromColor(color: string): 'light' | 'dark' {
  let r: number, g: number, b: number, hsp: number;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    const match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    if (!match) return 'light'; // fallback
    r = parseInt(match[1], 10);
    g = parseInt(match[2], 10);
    b = parseInt(match[3], 10);
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    const hex = +('0x' + color.slice(1).replace(
      color.length < 5 && /./g, '$&$&'
    ));
    r = hex >> 16;
    g = hex >> 8 & 255;
    b = hex & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
  );

  // Using the HSP value, determine whether the color is light or dark
  return hsp > 127.5 ? 'light' : 'dark';
} 